"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timer = void 0;
const core_1 = require("flow-connect/core");
const ui_1 = require("flow-connect/ui");
class Timer extends core_1.Node {
    constructor() {
        super();
        this.lastTrigger = Number.MIN_VALUE;
    }
    setupIO() {
        this.addTerminals([{ type: core_1.TerminalType.OUT, name: "timer", dataType: "event" }]);
    }
    created(options) {
        const { width = 120, name = "Timer", style = {}, state = {} } = options;
        this.width = width;
        this.name = name;
        this.style = Object.assign({ rowHeight: 10 }, style);
        this.state = Object.assign(Object.assign({}, Timer.DefaultState), state);
        this.setupUI();
        this.setupListeners();
    }
    process() { }
    setupUI() {
        this.ui.append(this.createUI("core/input", {
            propName: "delay",
            height: 20,
            style: { type: ui_1.InputType.Number },
        }));
    }
    setupListeners() {
        this.flow.on("tickreset", () => (this.lastTrigger = Number.MIN_VALUE));
        this.flow.on("tick", () => {
            let current = this.flow.flowConnect.time;
            if (current - this.lastTrigger >= this.state.delay) {
                this.outputs[0].emit(this.state.emitValue);
                this.lastTrigger = current;
            }
        });
    }
}
exports.Timer = Timer;
Timer.DefaultState = { delay: 1000, emitValue: null };
